import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import '../../assets/styles/header.css';
import { logoEnum } from '../Common/headerenum';
interface FacilityProps {
    facility: {
        name: string;
        localTime: string;
        operatorid: number;
    };
}
const DashboardHeader: React.FC<FacilityProps> = ({ facility }) => {
    const operatorid = facility.operatorid

    return (
        <Box p={1} bgcolor={'common.white'} borderRadius={'5px'} boxShadow={1}>
            <Stack direction={'row'} alignItems={'center'} useFlexGap flexWrap={'wrap'} spacing={2}>
                <Typography
                    component="div"
                    className={logoEnum[operatorid as keyof typeof logoEnum]?.logname}
                    title='Store-Space'
                    sx={{ width: '220px', height: '200px' }}
                >
                </Typography>

                <Box>
                    <Typography mb={1.2} variant='h2' color='text.secondary'>
                        {facility.name}
                    </Typography>
                    <Typography color='text.secondary' fontWeight={500}>
                        Local time: {facility.localTime}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    );
};
export default DashboardHeader;
